import { InjectionToken } from '@angular/core';

/**
 * The organization key the URL named when Keycloak knows no organization by it, or `undefined`.
 * Provided by `createAppConfig` from what `main.ts` read off the refused login; its own file so the
 * application config does not pull the lazily loaded no-organization page into the main bundle.
 */
export const UNKNOWN_ORGANIZATION = new InjectionToken<string | undefined>('UNKNOWN_ORGANIZATION', { factory: () => undefined });
